// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.area-form[data-v-641d18b7] {\n  max-width: 346px;\n}\n.text-forgot[data-v-641d18b7] {\n  color: #45505f;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 21px;\n}\n@media screen and (max-width: 820px) {\n.text-forgot[data-v-641d18b7] {\n    color: #ff5c00;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
